import { l as lodashExports } from '../_virtual/lodash.js';
import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { a as Element, E as Editor } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import { NodeUtils } from './node-utils.js';

const SerializationUtils = {
  escapeText(text) {
    return lodashExports.escape(text);
  },
  /**
   * 获取直接的子元素
   * @param editor Editor对象
   * @returns 子元素集合
   */
  getDirectChildElements(editor) {
    return lodashExports.cloneDeep(editor.children).filter(
      (node) => Element.isElement(node) && !Editor.isEmpty(editor, node)
    );
  },
  serializeNode(node, serializers) {
    if (NodeUtils.isTextNode(node)) {
      return this.escapeText(node.text.trim());
    } else if (NodeUtils.isElementNode(node)) {
      const type = NodeUtils.getNodeType(node);
      const children = node.children.map((n) => this.serializeNode(n, serializers)).join("");
      for (const serializationMethod of serializers) {
        if (type === serializationMethod.type) {
          return serializationMethod.serializer(node, children);
        }
      }
      return children;
    }
    return "";
  },
  serializeNodes(nodes, serializers) {
    return nodes.map((node) => {
      return this.serializeNode(node, serializers);
    }).filter((text) => {
      return text.trim();
    });
  },
  existTextNode(nodes) {
    for (const node of nodes) {
      if (NodeUtils.isTextNode(node)) {
        return true;
      }
    }
    return false;
  }
};

export { SerializationUtils };
//# sourceMappingURL=serialization-utils.js.map
